import { render, staticRenderFns } from "./accountingLedger.vue?vue&type=template&id=153d2b5d&scoped=true&"
import script from "./accountingLedger.vue?vue&type=script&lang=js&"
export * from "./accountingLedger.vue?vue&type=script&lang=js&"
import style0 from "./accountingLedger.vue?vue&type=style&index=0&id=153d2b5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153d2b5d",
  null
  
)

export default component.exports